import { render, staticRenderFns } from "./InitialStep.vue?vue&type=template&id=c7836d64&scoped=true"
import script from "./InitialStep.vue?vue&type=script&lang=js"
export * from "./InitialStep.vue?vue&type=script&lang=js"
import style0 from "./InitialStep.vue?vue&type=style&index=0&id=c7836d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7836d64",
  null
  
)

export default component.exports